<template>
  <span class="attachment-adder">
    <span class="trigger" @click="handleClick">
      <slot>
        <el-button type="primary" size="small" icon="el-icon-plus">添加附件</el-button>
      </slot>
    </span>

    <el-dialog title="添加附件" :visible.sync="visible" width="500px" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" size="small" label-width="80px">
        <el-form-item prop="title" label="标题：">
          <el-input v-model="form.title" placeholder="请输入附件标题" maxlength="50" show-word-limit></el-input>
        </el-form-item>

        <el-form-item prop="tag" label="标签：">
          <el-input v-model="form.tag" placeholder="请输入标签" maxlength="30" show-word-limit></el-input>
        </el-form-item>

        <el-form-item prop="description" label="描述：">
          <el-input type="textarea" v-model="form.description" placeholder="请输入描述" :rows="3" maxlength="200"
            show-word-limit></el-input>
        </el-form-item>

        <el-form-item prop="url" v-if="url" label="链接：">
          <template>
            <el-input :value="url" placeholder="正在获取链接..." readonly>
              <i slot="suffix" class="el-icon-check" style="color: #67C23A"></i>
            </el-input>
          </template>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false" size="small">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="loading" size="small">确定</el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { addWorkflowAttachment } from "@/api/workflow";
import { Toolkit } from "@/util";

export default {
  name: "AttachmentAdder",
  props: {
    // 附件类型（必需）
    attachmentType: {
      type: String,
      required: true
    },
    // 业务ID（
    bizId: {
      type: [String, Number],
      default: null
    },


    url: {
      type: String,
      default: null
    },


  },
  data() {
    return {
      visible: false,
      loading: false,
      gettingUrl: false,
      form: {
        title: "",
        tag: "",
        description: "",
        url: ""
      },
      rules: {
        title: [{ required: true, message: "请输入附件标题", trigger: "blur" }],
        tag: [{ required: true, message: "请输入标签", trigger: "blur" }],
      }
    };
  },
  methods: {
    handleClick() {
      this.visible = true;
      this.resetForm();
    },
    resetForm() {
      this.form = {
        title: "",
        tag: "",
        description: "",
        url: ""
      };
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },


    async handleSubmit() {
      const valid = await this.$refs.form.validate().catch(() => false);
      if (!valid) return;

      this.loading = true;
      try {
        const params = {
          attachmentType: this.attachmentType,
          bizId: this.bizId ? String(this.bizId) : null,
          title: this.form.title,
          tag: this.form.tag,
          description: this.form.description,
          url: this.url
        };

        await addWorkflowAttachment(Toolkit.filterEmpty(params));
        this.$message.success("添加附件成功");
        this.visible = false;
        this.$emit("success");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.attachment-adder {
  display: inline-block;
}

.trigger {
  cursor: pointer;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
</style>
